import React, { useEffect, useState } from 'react';

import lunchLogo from '../../../img/logo-lunch-team.svg';

import './privacyTerms.scss';

export function PrivacyTerms() {
  const [content, setContent] = useState();

  const privacyPolicyTermsURL =
    'https://s3-eu-west-1.amazonaws.com/lunchteam-privacy-policy/staging/en/privacy_policy1.1.txt';

  const getPrivacyContent = async () => {
    const result = await fetch(privacyPolicyTermsURL).then(result =>
      result.text()
    );

    setContent(result);
  };

  useEffect(() => {
    getPrivacyContent();
  }, []);

  return (
    <main className="main">
      <header className="head">
        <img src={lunchLogo} alt="Lunch Team Logo" />
      </header>

      <div className="content-terms">
        <a href="/Menu" className="back-link">
          Back
        </a>
        <h2>Privacy Policy</h2>
        <div
          className="text-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Landing/PrivacyTerms/index.js